import {
  Component,
  Input,
  ViewChild,
  ViewContainerRef,
} from "@angular/core";
import { CustomDialogService } from "src/app/shared/services/custom-dialog.service";
import { CostEstimationPart } from "../../models/CostEstimationPart";

@Component({
  selector: "app-cost-estimation-parts",
  templateUrl: "./cost-estimation-parts.component.html",
  styleUrls: ["./cost-estimation-parts.component.scss"],
})
export class CostEstimationPartsComponent {
  constructor(private customDialogService: CustomDialogService) {}
  @Input() costEstimationParts: CostEstimationPart[];
  @Input() viewMode: boolean;


  @ViewChild("costEstimationPartsDialog", { read: ViewContainerRef })
  public dialogContainerRef: ViewContainerRef;

  toogleIncludePartInPartsOrder(part: CostEstimationPart) {
    part.includeInPartsOrder = !part.includeInPartsOrder;

    if (!part.includeInPartsOrder) {
      this.customDialogService.actionWithTextSelection(
        "claims-center.claimCostEstimations.setReasonForNotOrdering",
        (text: string) => {
          part.reasonForNotOrdering = text;
        },
        "",
        true,
        this.dialogContainerRef
      );
    } else {
      part.reasonForNotOrdering = "";
    }
  }
}
